import types from '@/vuex/busca-documentos/mutations-types'
// import dates from '@/utils/dates'

const mutations = {
  [types.EXIBIR_DIALOG_INTERESSADO]: (state) => {
    state.dialogInteressado = true
  },
  [types.ESCONDER_DIALOG_INTERESSADO]: (state) => {
    state.dialogInteressado = false
  },
  [types.EXIBIR_DIALOG_RESPONSAVEL_TRAMITACAO]: (state) => {
    state.dialogResponsavelTramitacao = true
  },
  [types.ESCONDER_DIALOG_RESPONSAVEL_TRAMITACAO]: (state) => {
    state.dialogResponsavelTramitacao = false
  },
  [types.SET_LISTA_TIPOS_DOCUMENTO]: (state, payload) => {
    state.listaTiposDocumento = payload.listaTiposDocumento
  },
  [types.SET_LISTA_TIPO_INTERESSADO]: (state, payload) => {
    state.listaTiposInteressado = payload.listaTiposInteressado
  },
  [types.SET_LISTA_INTERESSADOS]: (state, payload) => {
    state.listaEntidadeInteressada = payload.listaEntidadeInteressada
  },
  [types.SET_TIPO_INTERESSADO]: (state, payload) => {
    state.tipoInteressado = payload.tipoInteressado
  },
  [types.SET_INTERESSADO]: (state, payload) => {
    state.interessado = payload.interessado
  },
  [types.SET_LISTA_TIPO_RESPONSAVEL_TRAMITACAO]: (state, payload) => {
    state.listaTiposResponsavelTramitacao = payload.listaTiposResponsavelTramitacao
  },
  [types.SET_LISTA_RESPONSAVEL_TRAMITACAO]: (state, payload) => {
    state.listaEntidadeResponsavelTramitacao = payload.listaEntidadeResponsavelTramitacao
  },
  [types.SET_TIPO_RESPONSAVEL_TRAMITACAO]: (state, payload) => {
    state.tipoResponsavelTramitacao = payload.tipoResponsavelTramitacao
  },
  [types.SET_RESPONSAVEL_TRAMITACAO]: (state, payload) => {
    state.responsavelTramitacao = payload.responsavelTramitacao
  },
  [types.SET_LISTA_DOCUMENTOS]: (state, payload) => {
    state.listaDocumentos = payload.listaDocumentos
  },
  [types.SET_LISTA_UNIDADES_PROCEDENCIA]: (state, payload) => {
    state.listaUnidadesProcedencia = payload.listaUnidadesProcedencia
  },
  [types.SET_LISTA_SERVIDORES_PROCEDENCIA]: (state, payload) => {
    state.listaServidoresProcedencia = payload.listaServidoresProcedencia
  },
  [types.SET_BUSCANDO_DOCUMENTOS]: (state, payload) => {
    state.buscandoDocumentos = payload.buscandoDocumentos
  }
}
export default mutations
